import React from 'react';
import { isEmpty } from 'lodash';
import { connect } from 'react-redux';

import { PATH } from '../../../constants/path';

import {
    passwordResetInitUsername,
    passwordResetInitEmail
} from '../../../services/authentication/resetpassword/actions';

import {
    FormComponent,
    EmailInputFieldComponent,
    TextInputFieldComponent,
    LegendFieldComponent
} from '../../../components/form';
import { HeadComponent } from '../../HeadComponent';
import { withTemplate } from '../../template/withTemplate';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';
import { SuccessInfoComponent } from '../../form/SuccessInfoComponent';
import LocalizedBreadcrumbItem from '../../breadcrumb/LocalizedBreadcrumbsItem';

import './PasswordResetInitFormComponent.scss';

class PasswordResetInitFormComponent extends React.Component {
    handleSubmitUsername = data => {
        this.props.passwordResetInitUsername(data);
    };

    handleSubmitEmail = data => {
        this.props.passwordResetInitEmail(data);
    };

    renderForm = username => {
        const {
            i18n,
            i18nForm,
            requestSubmitUsername,
            requestSubmitEmail,
            successSubmitUsername,
            successSubmitEmail,
            errorSubmitUsername,
            errorSubmitEmail,
            errorMessageUsername,
            errorMessageEmail
        } = this.props;

        const requestSubmit = username ? requestSubmitUsername : requestSubmitEmail;
        const successSubmit = successSubmitUsername || successSubmitEmail;
        const errorSubmit = username ? errorSubmitUsername : errorSubmitEmail;
        const errorMessage = username ? errorMessageUsername : errorMessageEmail;

        if (!successSubmit) {
            return (
                <FormComponent
                    form={`password-reset-init-form-${username ? 'username' : 'email'}`}
                    onSubmit={username ? this.handleSubmitUsername : this.handleSubmitEmail}
                    requestSubmit={requestSubmit}
                    errorSubmit={errorSubmit}
                    submitText={i18n.form.SUBMIT}>
                    {username ? (
                        <TextInputFieldComponent
                            name="username"
                            label={i18nForm.PLACEHOLDER_USERNAME}
                            placeholder={i18nForm.PLACEHOLDER_USERNAME}
                            isRequired
                        />
                    ) : (
                        <EmailInputFieldComponent
                            name="email"
                            label={i18n.form.placeholder.EMAIL}
                            placeholder={i18n.form.placeholder.EMAIL}
                            isRequired
                        />
                    )}
                    {errorMessage && (
                        <LegendFieldComponent classNameInputContainer="color-err">
                            {errorMessage}
                        </LegendFieldComponent>
                    )}
                </FormComponent>
            );
        }
    };

    renderSuccessMessage = () => {
        const { successSubmitUsername, successSubmitEmail, i18n } = this.props;
        const successSubmit = successSubmitUsername || successSubmitEmail;

        if (successSubmit) {
            return (
                <SuccessInfoComponent>
                    <p>{i18n.form.SUCESS_MESSAGE}</p>
                </SuccessInfoComponent>
            );
        }
    };

    render() {
        const { i18n, successSubmitUsername, successSubmitEmail } = this.props;
        return (
            <main className="conteneur conteneur-mobile" id="p-reset-password">
                <HeadComponent title={i18n.TITLE} description={i18n.DESCRIPTION} />
                <LocalizedBreadcrumbItem to={PATH.FORGOTTEN_PASSWORD_PATH}>
                    {i18n.BREADCRUMB}
                </LocalizedBreadcrumbItem>
                <h1>{i18n.PAGE_TITLE}</h1>
                <p className="subtitle">{i18n.SUBTITLE}</p>
                <div className="grid-3 has-gutter">
                    {this.renderForm()}
                    {!successSubmitUsername && !successSubmitEmail && (
                        <LegendFieldComponent classNameInputContainer="or">
                            {i18n.OR}
                        </LegendFieldComponent>
                    )}
                    {this.renderForm(true)}
                </div>
                {this.renderSuccessMessage()}
            </main>
        );
    }
}

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.PASSWORDRESET.INITIALIZATION,
        i18nForm: state.i18n.feature.form,
        errorMessageUsername:
            state.authentication.resetpassword.errorPasswordResetInitUsername || '',
        errorMessageEmail: state.authentication.resetpassword.errorPasswordResetInitEmail || '',
        requestSubmitUsername:
            state.authentication.resetpassword.fetchingPasswordResetInitUsername || false,
        requestSubmitEmail:
            state.authentication.resetpassword.fetchingPasswordResetInitEmail || false,
        successSubmitUsername:
            state.authentication.resetpassword.successPasswordResetInitUsername || false,
        successSubmitEmail:
            state.authentication.resetpassword.successPasswordResetInitEmail || false,
        errorSubmitUsername: !isEmpty(
            state.authentication.resetpassword.errorPasswordResetInitUsername
        ),
        errorSubmitEmail: !isEmpty(state.authentication.resetpassword.errorPasswordResetInitEmail)
    };
};

const mapDispatchToProps = {
    passwordResetInitUsername,
    passwordResetInitEmail
};

export default withTemplate(
    connect(mapStateToProps, mapDispatchToProps)(PasswordResetInitFormComponent),
    PrimaryTemplate
);



// WEBPACK FOOTER //
// ./src/components/pages/resetpassword/PasswordResetInitFormComponent.js